import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions/dashboardactions";
import {
    CHART_TYPE_PIE,
    CHART_TYPE_BAR,
    CHART_TYPE_LINE,
    CHART_TYPE_CARD,
    CHART_TYPE_DOUGHNUT,
    CHART_TYPE_TABLE,
    CHART_TYPE_LIST,
    CHART_TYPE_TASK_TABLE,
} from "../../constants";

import PiChart from "../PiChart/PiChart";
import BarChart from "../BarChart/BarChart";
import LineChart from "../LineChart/LineChart";
import Cards from "../Cards/Cards";
import Table from "../Table/Table";
import TaskManagementTable from "../TaskManagementTable/TaskManagementTable";
import DoughnutChart from "../DoughnutChart/DoughnutChart";
import PreLoadingIndicator from "../../../../components/PreLoadingIndicator";
import List from "../List/List";

export default function ChartContainer({ dashboardId }) {
    const dispatch = useDispatch();
    const state = useSelector(
        (state) => state.dashboardReducer
    );

    const userDashboardData = useSelector(
        (state) => state.dashboardReducer.userDashboard.userdashboardData
    );
    useEffect(() => {
        dispatch(actions.getDashboardData(dashboardId));
    }, [state.fromDate, state.toDate, state.system, state.branch, state.multipleSelectedValues, state.salesChanelId]);
    if (!userDashboardData) {
        return <PreLoadingIndicator />
    }
    const data = userDashboardData["" + dashboardId + ""];
    if (!data) {
        return <PreLoadingIndicator />
    }
    console.log('ChartContainer data', data)
    let chartComponent = null;
    switch (data.dashboardType) {
        case CHART_TYPE_CARD:
            chartComponent = <Cards dashboardId={data.dashboardId} />;
            break;
        case CHART_TYPE_PIE:
            chartComponent = <PiChart dashboardId={data.dashboardId} />;
            break;
        case CHART_TYPE_DOUGHNUT:
            chartComponent = <DoughnutChart dashboardId={data.dashboardId} />;
            break;
        case CHART_TYPE_BAR:
            chartComponent = <BarChart dashboardId={data.dashboardId} />;
            break;
        case CHART_TYPE_LINE:
            chartComponent = <LineChart dashboardId={data.dashboardId} />;
            break;
        case CHART_TYPE_TABLE:
            chartComponent = <Table dashboardId={data.dashboardId} />;
            break;
        case CHART_TYPE_LIST:
            chartComponent = <List dashboardId={data.dashboardId} />;
            break;
        case CHART_TYPE_TASK_TABLE:
            chartComponent = <TaskManagementTable dashboardId={data.dashboardId} />;
            break;
        default:
            console.log(`Unknown dashboard type: ${data.dashboardType}`);
            return <div />;
    }

    return <>{chartComponent}</>;
}
